export default __webpack_public_path__ + "1a223ec138c405050b3e71e5dc3b68cd.svg";